/** Complete server-owned scope for lifecycle events outside a paginated list. */
export interface ResponseSubjectScope {
  readonly field: string;
  readonly templates: readonly string[];
}

export function readResponseSubjectIds(value: unknown): readonly string[] {
  if (
    !Array.isArray(value) ||
    !value.every((id) => typeof id === 'string' && /^[1-9A-HJ-NP-Za-km-z]{32,44}$/.test(id))
  ) {
    throw new Error('Invalid realtime response subject scope');
  }
  return [...new Set(value)].sort();
}

export function responseSubjects(
  response: unknown,
  scope: ResponseSubjectScope | undefined,
): readonly string[] {
  if (scope === undefined || response === undefined || response === null) return [];
  const ids = readResponseSubjectIds(
    (response as { responseSubjectIds?: unknown }).responseSubjectIds,
  );
  return ids.flatMap((id) => scope.templates.map((template) => template.replace('{id}', id)));
}
